import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { CloseJobAsCollaboratorDialog } from '@/features/jobs/CloseJobAsCollaboratorDialog'
import { type CloseJobAsCollaboratorDialogViewModel } from './CloseJobAsCollaboratorDialogViewModel'

export interface CloseJobAsCollaboratorDialogContainerProps {
  vm: CloseJobAsCollaboratorDialogViewModel | null
}

export const CloseJobAsCollaboratorDialogContainer = observer(
  function CloseJobAsCollaboratorDialogContainer({
    vm,
  }: CloseJobAsCollaboratorDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))

    if (!vm) {
      return null
    }

    return (
      <CloseJobAsCollaboratorDialog
        showing={vm.modal.showing}
        corporateMode={shellInfo.corporateMode}
        isSubmitPending={vm.submit.pending}
        isSubmitRejected={vm.submit.rejected}
        submitError={vm.submit.error}
        onClose={vm.modal.close}
        onSubmit={vm.submit}
        onDismissError={vm.submit.reset}
        submitButtonTestId="complete-job-button"
      />
    )
  },
)
